import React, { Component } from 'react'
import { Triangle } from '@segment/react-ui-library'
import css from './TableSection.module.css'

export class TableSection extends Component {
  constructor (props) {
    super(props)

    this.toggleOpen = this.toggleOpen.bind(this)

    if (typeof props.isOpen !== 'undefined') {
      this.state = {
        isOpen: props.isOpen
      }
    } else {
      this.state = {
        isOpen: true
      }
    }
  }

  render () {
    const { isOpen } = this.state
    const { title, subtitle, children, extra } = this.props

    return (
      <div>
        <div onClick={this.toggleOpen} className={css.header}>
          <Triangle width='12px' top='2px' position='relative' aim={isOpen ? 'down' : 'right'} />
          <div className={css.titleGroup}>
            <div className={css.titleContainer}><span className={css.title}>{title}</span> <span>{extra}</span></div>
            <div className={css.subtitle}>{subtitle}</div>
          </div>
        </div>
        {isOpen && (
          <div className={css.body}>
            {children}
          </div>
        )}
      </div>
    )
  }

  toggleOpen () {
    this.setState({ isOpen: !this.state.isOpen })
  }
}

export default TableSection



// WEBPACK FOOTER //
// ./components/Customers/presentational/TableSection.js